import { Alert, Button, Drawer, Field, Input, Select } from '@itds/elements/index.js';
import { PASSWORD_RULES, STATES } from '@itds/Constants';
import React, { useEffect, useState } from 'react';

import Api from '@brokerage/utils/Api';
import { Colors } from '@itds/Theme';
import FormUtils from '@itds/utils/Form';
import PropTypes from 'prop-types';

const New = ({ onClose, onSave, show }) => {
  const styles = {
    password_rule: {
      marginBottom: 10
    },
    password_rule_valid: {
      color: '#999'
    },
    icon: {
      fontSize: 20,
      verticalAlign: 'middle',
      color: '#ccc',
      marginRight: 2
    },
    icon_green: {
      fontSize: 20,
      verticalAlign: 'middle',
      color: Colors.GREEN.hex,
      marginRight: 2
    }
  };
  const [data, setData] = useState({
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    phone: '',
    gender: 'Male',
    state: 'AL'
  });
  const [errors, setErrors] = useState([]);
  const [save_error, setSaveError] = useState(false);

  useEffect(() => {
    setData({
      email: '',
      password: '',
      first_name: '',
      last_name: '',
      phone: '',
      gender: 'Male',
      state: 'AL'
    });
  }, [show]);

  const handleInputChange = (name, e) => {
    const errors = [];

    setData({ ...data, [name]: e.target.value });

    if (name === 'password') {
      const password = e.target.value;

      PASSWORD_RULES.forEach(rule => {
        if (!rule.pattern.test(password)) {
          errors.push(name, rule.name);
        }
      });
    }

    setErrors(errors);
  };

  const handleSave = () => {
    const saveErrors = [...errors];

    if (!data.first_name) {
      saveErrors.push('first_name');
    }

    if (!data.last_name) {
      saveErrors.push('last_name');
    }

    if (!FormUtils._validateEmail(data.email)) {
      saveErrors.push('email');
    }

    if (!FormUtils._validatePhone(data.phone)) {
      saveErrors.push('phone');
    }

    setErrors(saveErrors);

    if (!errors.length) {
      Api.createMember(data)
        .then(data_ => {
          setSaveError(false);
          onSave(data_);
        })
        .catch(() => {
          setSaveError(true);
        });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={handleSave}>Create Member</Button>}
      onClose={onClose}
      show={show}
      title='Add Member'
    >
      {save_error ? (
        <Alert type='error'>
          Unable to create member at this time. It's most likely because the member already exists.
        </Alert>
      ) : null}

      <Field label='Email'>
        <Input
          invalid={errors.includes('email')}
          onChange={handleInputChange.bind(null, 'email')}
          required={true}
          value={data.email}
        />
      </Field>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Field label='First Name' style={{ width: '49%' }}>
          <Input
            invalid={errors.includes('first_name')}
            onChange={handleInputChange.bind(null, 'first_name')}
            required={true}
            value={data.first_name}
          />
        </Field>
        <Field label='Last Name' style={{ width: '49%' }}>
          <Input
            invalid={errors.includes('last_name')}
            onChange={handleInputChange.bind(null, 'last_name')}
            required={true}
            value={data.last_name}
          />
        </Field>
      </div>

      <Field label='Phone Number'>
        <Input
          format='phone'
          invalid={errors.includes('phone')}
          onChange={handleInputChange.bind(null, 'phone')}
          required={true}
          value={data.phone}
        />
      </Field>

      <Field label='Gender'>
        <Select
          invalid={errors.includes('gender')}
          onChange={handleInputChange.bind(null, 'gender')}
          options={[{ value: 'Male' }, { value: 'Female' }]}
          required={true}
          value={data.gender}
        />
      </Field>

      <Field label='State'>
        <Select
          invalid={errors.includes('state')}
          onChange={handleInputChange.bind(null, 'state')}
          options={STATES}
          required={true}
          value={data.state}
        />
      </Field>

      <Field label='Password'>
        <Input
          invalid={errors.includes('password')}
          onChange={handleInputChange.bind(null, 'password')}
          required={true}
          type='password'
          value={data.password}
        />
      </Field>

      {data.password &&
        PASSWORD_RULES.map(rule => {
          const is_valid = !errors.includes(rule.name);

          return (
            <div
              key={rule.name}
              style={Object.assign(
                {},
                styles.password_rule,
                is_valid && styles.password_rule_valid
              )}
            >
              {is_valid ? (
                <i className='mdi mdi-checkbox-marked-circle-outline' style={styles.icon_green} />
              ) : (
                <i className='mdi mdi-checkbox-blank-circle-outline' style={styles.icon} />
              )}{' '}
              {rule.label}
            </div>
          );
        })}
    </Drawer>
  );
};

New.propTypes = {
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default New;
